import configExists from './configExists';

export default configExists;
